/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import Request from '../../utils/request';
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import "./style.less";

const details = {
  "goodsId": 123,
  "goodsName": "iPhone 18",
  "subtitle": "买就送air pods",
  "goodsUrl": "https://item.taobao.com/item.htm?id=684824549373",
  "imgUrl": "https://static.shihuocdn.cn/admin/files/20221211/1d91ecea5b28a6a426fe74c59d2455f8.jpeg",
  "price": "99.80",
  "discountPrice": "88.80",
  "sale": "1000w+",
  "tags": [
      "包邮",
      "假一赔万"
  ],
  "shopName": "苹果官网",
  "shopId": "666888",
  "shopUrl": "https://shop.m.taobao.com/shop/shop_index.htm?user_id=890482188&item_id=681719765292",
  "specs": [
      {
          "name": "颜色",
          "attrs": [
              {
                  "name": "白色",
                  "image": "https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"
              },
              {
                  "name": "黑色",
                  "image": "https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"
              }
          ]
      },
      {
          "name": "尺码",
          "attrs": [
              {
                  "name": "L"
              },
              {
                  "name": "M"
              },
              {
                  "name": "S"
              }
          ]
      }
  ],
  "postage": "免运费",
  "Details": [
    {
      "Type": "Image",
      "Content": "https://img.alicdn.com/imgextra/i2/2819894826/O1CN01qgh0Yl1lWLzzGS4Op_%21%212819894826.jpg"
    },
    {
      "Type": "Image",
      "Content": "https://img.alicdn.com/imgextra/i3/2819894826/O1CN019NgjxY1lWLzyCSxcL_%21%212819894826.jpg"
    },
    {
      "Type": "Text",
      "Content": "这是图文详情的文本类型"
    }
  ],
  "extraShow": [
    "自定义1",
    "自定义2"
  ],
  "extraExport": [
    "自定义3",
    "自定义4"
  ]
}

class PipelineCheckAppDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      platform: "",
      detail: {},
      url: "",
      pageShow: false
    };
  }

  componentDidMount() {
    window.addEventListener("message", this.receiveMessage, false);
  }

  destroyed() {
    typeof window !== "undefined" && window.removeEventListener("message", this.receiveMessage, false);
  }

  imgProxy = (origin) => {
    let base64 = window.btoa(unescape(encodeURIComponent(origin)))
    base64 = base64.replace(new RegExp("/", "g"), "_")
    base64 = base64.replace(new RegExp('\\+', "g"), "-")
    base64 = base64.replace(new RegExp('=', "g"), "")
    return `https://proxy.shihuocdn.cn/${base64}`
  }

  // 详情页数据
  getDetail = async(data) => {
    console.log('======== getDetail Lego获取到数据 ========', data);
    let detail = {}, platform = '';
    if (data) {
      detail = data.data ? JSON.parse(data.data) : {};
    } else {
      detail = details;
    }

    if (detail.imgUrl && detail.imgUrl.indexOf('shihuo') >= 0) {
      console.log('识货平台')
      const id = detail.goodsId;
      platform = 'shihuo';
      detail = await this.getProductDetail('goodsId', id);
    }

    this.setState({
      pageShow: true,
      platform,
      detail
    }, () => {
      this.initSwiper();
    });
  }

  getProductDetail = (type, id) => {
    let reqUrl;
    if (type === "goodsId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else if (type === "styleId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    } else if (type === "skuId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    }
    const idList = [id];
    return new Promise((resolve) => {
      Request({
        url: reqUrl,
        method: "post",
        withCredentials: true,
        data: {
          ids: idList,
          sort_tag: 0,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          const list = res.data.data.List;
          let result = {};
          if (list && list.length > 0) {
            const { goods_id, title, recommend, url, image, price, sell_point_str } = list[0];
            result = {
              "goodsId": goods_id,
              "goodsName": title,
              "subtitle": recommend,
              "goodsUrl": url,
              "imgUrl": image,
              "price": price,
              "discountPrice": "",
              "sale": sell_point_str,
              "tags": [],
              "shopName": "",
              "shopId": "",
              "shopUrl": "",
              "specs": [],
              "postage": "",
              "Details": [],
              "extraShow": [],
              "extraExport": []
            }
          }
          resolve(result);
        } else {
          resolve({});
        }
      }); 
    });
  }

  initSwiper = () => {
    var mySwiper = new Swiper('.banner', {
      autoplay: false,
      loop: false
    })
  }

  receiveMessage = (event) => {
    console.log('receiveMessage', event);
    const { messageType = '', data = '' } = event.data;
    switch (messageType) {
      case '详情数据':
        this.getDetail(data);
        break;
      case '清除数据':
        this.clearData();
        break;
      default:
        break;
    }
  }

  clearData = () => {
    this.setState({
      pageShow: false,
      detail: {}
    }, () => {
      typeof window !== "undefined" && window.location.reload();
    })
  }

  imageUrl(origin) {
    return `https://proxy.shihuocdn.cn/${window.btoa(unescape(encodeURIComponent(origin)))}`
  }

  // 进入店铺
  goShop = (url) => {
    url && window.open(url);
  }

  render() {
    const { detail = {}, platform = '', pageShow } = this.state;
    const { specs = [] } = detail;
    if (!pageShow) {
      return null;
    }
    return(
      <div className="pipeline-checkAppDetail">
        <div className="banner swiper">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              { detail.imgUrl && <img src={this.imgProxy(detail.imgUrl)} alt="" /> }
            </div>
          </div>
        </div>
        <div className="detail-info">
          <div className="price-info">
            <p className="price">{detail.price && `¥${detail.price}`}</p>
            { detail.discountPrice && <p className="discount-price">{`券后价 ¥${detail.discountPrice} 起`}</p> }
            { platform === 'shihuo' && detail.goodsId && <p className="goods-id">{`goodsId：${detail.goodsId}`}</p> }
          </div>
          <p className="title">{detail.goodsName}</p>
          <p className="sub-title">{detail.subtitle}</p>
        </div>
        {
          specs && specs.length > 0 && (
            <div className="size-color">
              {
                specs.map((item, index) => {
                  return (
                    <div className="attr-wrap" key={`attr-${index}`}>
                      <label className="label">{item.name}</label>
                      <ul className="attr">
                        {
                          item && item.attrs && item.attrs.length > 0 && item.attrs.map((value, key) => {
                            return (
                              <li key={`attr-item-${key}`} style={{padding: value.image && 0, fontSize: value.image && 0, lineHeight: value.image && "normal"}}>
                                { value.image ? <img src={this.imgProxy(value.image)} alt="" /> : value.name }
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  )
                })
              }
            </div>
          )
        }
        {
          platform !== 'shihuo' && (
            <div className="service">
              {
                detail.postage && (
                  <div className="freight">
                    <label className="label">运费</label>
                    <p>{detail.postage}</p>
                  </div>
                )
              }
              {
                detail.tags && detail.tags.length > 0 && (
                  <ul className="tags">
                    { 
                      detail.tags.map((item, index) => {
                        if (item) {
                          return (
                            <li key={`tag-item-${index}`}>
                              <img src="https://static.shihuocdn.cn/admin/files/20221214/6b3c18f9b4aaaa33469af8e9211d485c.png" alt="" />
                              <p>{item}</p>
                            </li>
                          )
                        } else {
                          return null
                        }
                      }) 
                    }
                  </ul>
                )
              }
            </div>
          )
        }
        {
          platform !== 'shihuo' && (
            <div className="extra-info">
              {
                detail.shopName && (
                  <div className="shop-info">
                    <p className="">{detail.shopName}</p>
                  </div>
                )
              }
              { detail.shopUrl && <div className="shop-btn" onClick={() => this.goShop(detail.shopUrl)}>进入店铺</div> }
              {
                detail.Details && detail.Details.length > 0 && (
                  <div className="desc-info">
                    {
                      detail.Details.map((item, index) => {
                        if (item.Type === 'Image') {
                          return <img key={`desc-item-${index}`} src={this.imgProxy(item.Content)} alt="" />
                        }
                        if (item.Type === 'Text') {
                          return <p key={`desc-item-${index}`}>{item.Content}</p>
                        }
                      })
                    }
                  </div>
                )
              }
            </div>
          )
        }
      </div>
    )
  }
}

PipelineCheckAppDetail.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCheckAppDetail };
export default PipelineCheckAppDetail;



// WEBPACK FOOTER //
// ./components/pipeline-checkAppDetail/index.js